import LogRocket from 'logrocket';
import { type FC, useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SlabContext } from '@core/context/SlabContext';
import Enums from '@core/types/api/Enums';
import { hasStringValue } from '@core/utils/equality';
import { usePushNotifications } from '@web/hooks/usePushNotifications';
import { useSlabMutation } from '@web/hooks/useSlabMutation';

export const NOTIFICATION_ID_PARAM = 'notificationId';

const UnflaggedPushNotifications: FC = () => {
  usePushNotifications();

  const [searchParams, setSearchParams] = useSearchParams();
  const { mutateAsync: updateReadStatus } = useSlabMutation('PUT notification by ID');

  const notificationId = searchParams.get(NOTIFICATION_ID_PARAM);

  useEffect(() => {
    if (!hasStringValue(notificationId)) {
      return;
    }

    setSearchParams(
      (params) => {
        params.delete(NOTIFICATION_ID_PARAM);

        return params;
      },
      { replace: true },
    );

    updateReadStatus({
      args: { pathParams: { id: notificationId }, body: { isRead: true } },
    }).catch((error) => {
      LogRocket.error('Failed to mark a push notification as read', error);
    });
  }, [notificationId]);

  return null;
};

export const PushNotifications: FC = () => {
  const { userInfo } = useContext(SlabContext);

  if (!userInfo.hasFlags([Enums.FeatureFlagName.FeatureFlagNotificationCenter])) {
    return null;
  }

  return <UnflaggedPushNotifications />;
};
